/**
 * WASM module stub - actual implementation loaded dynamically
 * This file ensures TypeScript can resolve the module path
 */

// This is a stub file that will be replaced by actual WASM build
export default function init() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}

export function elgamal_encrypt() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}

export function elgamal_decrypt() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}

export function elgamal_generate_keypair() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}

export function bulletproof_prove() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}

export function bulletproof_verify() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}

export function zk_prove_range() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}

export function zk_verify_range() {
  throw new Error('WASM module not built. Run: bun run build-wasm');
}